import { type AxiosResponse } from 'axios';

import { CreateAddressType, type CreateAdminType } from '@/types';

import { axiosPost } from '@/api/AxiosApi';
import { sendRequest } from '@/api/AxiosRequest';
import { type CustomAxiosResponse } from '@/api/AxiosResponse';

// 관리자 아이디 생성
export const createAdminLogin = async (aData: CreateAdminType): Promise<CustomAxiosResponse> => {
  const payload = {
    path: '/admin-login',
    body: { ...aData },
  };
  return sendRequest(payload, 'createAdmin', axiosPost);
};

// 관리자 지갑주소 추가
export const createAddress = async (aData: CreateAddressType) => {
  const payload = {
    path: '/admins',
    body: { ...aData },
  };
  return sendRequest(payload, 'createAddress', axiosPost);
};
